import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { fmtDateTime } from "@/components/common";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";

export default function PortalSyncCard() {
  const [s, setS] = useState(null);
  const load = () => api.get("/portal-sync/status").then(({ data }) => setS(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const running = ["queued", "running"].includes(s?.status);
  useEffect(() => { if (!running) return undefined; const t = setInterval(load, 3000); return () => clearInterval(t); }, [running]);
  const run = async () => {
    try { const { data } = await api.post("/portal-sync/run"); setS(data); toast.info("Sync started"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const c = s?.counts || {};
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 mb-6" data-testid="portal-sync-card">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div><div className="font-heading font-bold text-[#312E81]">Counselor Portal Sync</div><div className="text-xs text-slate-500">Pulls users, colleges, courses, fees, FAQs, leads, admissions and scholarships from counselor.ohcampus.com. Leads with the same mobile are merged.</div></div>
        <Button onClick={run} disabled={running} className="bg-[#4F46E5] hover:bg-[#4338CA]" data-testid="portal-sync-btn"><RefreshCw className={`w-4 h-4 mr-1 ${running ? "animate-spin" : ""}`} /> {running ? `Syncing ${s.step || ""}…` : "Sync now"}</Button>
      </div>
      {s?.id && (
        <div className="mt-3 text-xs text-slate-600" data-testid="portal-sync-status">
          <div>Last run: <b className={s.status === "failed" ? "text-rose-600" : s.status === "done" ? "text-emerald-600" : ""}>{s.status}</b> · started {fmtDateTime(s.started_at)} by {s.started_by}{s.finished_at ? ` · finished ${fmtDateTime(s.finished_at)}` : ""}</div>
          {s.error && <div className="text-rose-600 mt-1">{s.error}</div>}
          <div className="flex flex-wrap gap-2 mt-2">{Object.entries(c).map(([k, v]) => <span key={k} className="px-2 py-0.5 rounded-full bg-slate-100">{k.replace(/_/g, " ")}: <b>{v}</b></span>)}</div>
        </div>
      )}
    </div>
  );
}
